import React, { useState, useEffect, useRef } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useSelector, useDispatch } from 'react-redux'
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import _ from "lodash";
import { read, utils } from 'xlsx';

import { Table } from "../../helpers";
import Button from "../../helpers/Button";
import Menu from "../../helpers/Menu";
import Steps from "../../helpers/Steps";
import Loading from "../../common/Loading"
import ButtonGroup from "../../common/ButtonGroup";

import ErrorMsgsModal from "./Components/ErrorMsgsModal";
import AddRateContractProduct from "./Components/AddRateContractProduct";
import EditRateContractProduct from "./Components/EditRateContractProduct";
import Search from './Components/Search';
import BuyerRateContractTable from './Components/Table';

import { 
    getBuyerRateContractByValues,
    deleteBuyerRateContractById,
    insertBuyerRateContract,
    updateBuyerRateContract,
    insertBulkRateContractUploadSheet,
    updateBulkRateContractPriceUploadSheet,
    getBuyerRateContracts,
    getRateContractUploadStatus
} from "../../services/api/buyerRateContracts"
import { getCompanyERPCodeMap } from "../../services/api/companyERPCodeMap"
import { getBranchesList } from "../../services/api/companyBranch"
import { getMaterialMasterAndTempMaterialIds } from "../../services/api/materialMaster"
import { getCompanyById } from "../../services/api/company"

import { raiseToast } from '../../services/redux/reducers/toast/toast'
import { fetchHSNMasterData, fetchMaterialUoms, fetchGSTRates, fetchStatus, fetchMaterialBrands } from "../../services/redux/reducers/commonThunk"
import { fetchBuyerRateContract, updateBuyerRateContractData, updateSearchParams } from '../../services/redux/reducers/buyerRateContract/buyerRateContract'

import { excelSerialToJSDate, getDuplicatesInArray, isMobile } from "../../utils";

import { initialBuyerRateContractDetails } from "../../validation/buyerRateContractValidation";
import { getPMCompanyConfig } from "../../setup/pmCompanyConfig";


const BuyerRateContract = () => {
    const fileInputRef = useRef(null);

    const { id } = useParams()
    const navigate = useNavigate()
    const actionMenu = useRef(null)
    const dispatch = useDispatch()
    const toast = useRef(null)

    let [companyERPCodeMapData, setCompanyERPCodeMapData] = useState([])
    let [companyBranches, setCompanyBranches] = useState([])
    let [materialMasterAndTempMaterialIds, setMaterialMasterAndTempMaterialIds] = useState([])
    let [companyDetails, setCompanyDetails] = useState({})

    const [rateContractObj, setRateContractObj] = useState(initialBuyerRateContractDetails)
    const [editRateContractObj, setEditRateContractObj] = useState(initialBuyerRateContractDetails)
    const [initialRateContractObj, setInitialRateContractObj] = useState({})
    const [existingRateContractObj, setExistingRateContractObj] = useState(null)
    const [maxValidityPeriod, setMaxValidityPeriod] = useState(null)
    const [previousUnitPrice, setPreviousUnitPrice] = useState(null)
    
    const [searchInputs, setSearchInputs] = useState({
        searchBy: "all",
        searchText: ""
    })
    const [confirmMessageList, setConfirmMessageList] = useState([])
    const [errorMessagesData, setErrorMessagesData] = useState([])
    const [allBuyerRateContracts, setAllBuyerRateContracts] = useState([])
    const [validRateContractProducts, setValidRateContractProducts] = useState([])

    const [visibleAddRateContractProduct, setVisibleAddRateContractProduct] = useState(false)
    const [visibleEditRateContractProduct, setVisibleEditRateContractProduct] = useState(false)
    const [visibleUploadFileConfirmModal, setVisibleUploadFileConfirmModal] = useState(false)
    const [visibleErrorMessageModal, setVisibleErrorMessageModal] = useState(false)
    const [isFilterShown, setIsFilterShown] = useState(true)
    const [isLoaderVisible, setIsLoaderVisible] = useState(false)

    const buyerRateContractData = useSelector(state => state.buyerRateContract.buyerRateContractData)
    const isPageLoading = useSelector(state => state.buyerRateContract.loading)
    const paginationParams = useSelector(state => state.buyerRateContract.paginationParams)
    const searchParams = useSelector(state => state.buyerRateContract.searchParams)

    const userId = useSelector((state) => state.userDetails.userId)
    const HSNMasterData = useSelector((state) => state.common.HSNMaster)
    const uomsData = useSelector((state) => state.common.materialUOMs)
    const companyGSTRateData = useSelector((state) => state.common.GSTRates)
    const statusList = useSelector(state => state.common.status)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const userDetails = useSelector((state) => state.userDetails)

    const pmCompanyConfig = getPMCompanyConfig(userDetails.PMCompanyDetails.companyId)

    const isMobileDevice = isMobile()

    const [uploadStatus, setUploadStatus] = useState(null)
    const [isPolling, setIsPolling] = useState(false)

    useEffect(() => {
        let companyERPCodeMapParams = { 
            companyIds: [id], 
            statusId: 1, 
            paginator: false 
        }
        dispatch(fetchHSNMasterData())
        dispatch(fetchMaterialUoms())
        dispatch(fetchGSTRates())
        dispatch(fetchStatus())
        dispatch(fetchMaterialBrands())
        getCompanyDetailsById(id)
        getCompanyERPCodeMapData(companyERPCodeMapParams)
        getCompanyBranchData(id)
        getMaterialMasterAndTempMaterialIdsData()
        
        if(initialBuyerRateContractDetails.validityPeriod){
            setMaxValidityPeriod(initialBuyerRateContractDetails.validityPeriod)
        }
    }, [])

    useEffect(() => {
        getBuyerRateContractsData()
    }, [])

    useEffect(()=>{
        dispatch(updateSearchParams({...searchParams, companyIds: [id]}))
    }, [])

    const validateMonthlyValue = (monthlyQty, unitPrice, monthlyValue) => {
        const calculated = parseInt(monthlyQty) * parseInt(unitPrice)
        const actual = parseInt(monthlyValue)
    
        if (Math.abs(calculated - actual) > actual * 0.02) {
            return {
                isValid: false,
                expected: calculated,
                actual
            }
        }
        return { isValid: true }
    }

    const uploadMenu = useRef(null)
    
    const uploadOptions = [
        {
            label: 'Upload File',
            command: () => {
                const fileInput = document.getElementById('upload-xl-form');
                if (fileInput) {
                    fileInput.click()
                }
            },
            permissions: [155],
            disabled: companyDetails?.statusId === 2
        }
    ]

    const items = [
        {
            label: 'Company Details',
            command: () => { navigate(`/company/${id}`); }
        },
        {
            label: 'Users',
            command: () => { navigate(`/company/users/${id}`); }
        },
        {
            label: 'Branch',
            command: () => { navigate(`/company/branches/${id}`); }
        },
        {
            label: 'Bank Accounts',
            command: () => { navigate(`/company/bank_details/${id}`); } 
        },
        {
            label: 'Rate Contract',
            command: () => { navigate(`/company/ratecontract/${id}`); }
        }
    ]

    if([2, 3].includes(companyDetails?.buyerSeller)){
        items.push(
            {
                label: 'Seller Profile',
                command: () => { navigate(`/company/seller-profile/${id}`); } 
            }
        )
    }

    const getBuyerRateContractsData = async () => {
        const buyerRateContractRes = await getBuyerRateContracts({companyIds: [id], statusId: 1, paginator: false})
        if(buyerRateContractRes.failure){ 
            return dispatch(raiseToast({severity:'error', detail: buyerRateContractRes.data.error, life: 3000}))
        }

        setAllBuyerRateContracts(buyerRateContractRes.data.data)
    }

    const getCompanyDetailsById = async() => {
        const companyDetailsResponse = await getCompanyById(id)
        console.log("companyDetailsResponse", companyDetailsResponse)
        if(companyDetailsResponse.failure){ 
            dispatch(raiseToast({severity:'error', detail: companyDetailsResponse.data.error, life: 3000}))
        }else{
            if(companyDetailsResponse?.data?.thirdPartyIntegrations?.meplatoCatalogId){
                companyDetailsResponse.data.meplatoCatalogId = companyDetailsResponse?.data?.thirdPartyIntegrations?.meplatoCatalogId
            }
            setCompanyDetails(companyDetailsResponse?.data)
        }
    }

    const getCompanyERPCodeMapData = async (companyERPCodeMapParams) => {
        const companyERPCodeMapResponse = await getCompanyERPCodeMap(companyERPCodeMapParams)
        console.log("companyERPCodeMap-response", companyERPCodeMapResponse)

        if (companyERPCodeMapResponse.failure){
            dispatch(raiseToast({severity:'error', detail: companyERPCodeMapResponse?.data?.error , life: 3000}))
        }else {
            setCompanyERPCodeMapData(companyERPCodeMapResponse.data.data)
        }
    }

    const getCompanyBranchData = async (companyId) => {
        const data = { companyIds: [companyId], sortBy: 'branchName', paginator: false }
        const companyBranchesResponse = await getBranchesList(data)
        console.log("companyBranches - response", companyBranchesResponse)

        if(companyBranchesResponse.failure){
            dispatch(raiseToast({severity:'error', detail: companyBranchesResponse?.data?.error , life: 3000}))
        }else{
            setCompanyBranches([{branchName:"ALL", branchId:0}, ...companyBranchesResponse.data.data])
        }
    }

    const getMaterialMasterAndTempMaterialIdsData = async() => {
        const materialMasterAndTempMaterialIdsResponse = await getMaterialMasterAndTempMaterialIds()
        console.log("materialMasterAndTempMaterialIds - response", materialMasterAndTempMaterialIdsResponse)

        if(materialMasterAndTempMaterialIdsResponse.failure){
            dispatch(raiseToast({severity:'error', detail: materialMasterAndTempMaterialIdsResponse?.data?.error , life: 3000}))
        }else{
            setMaterialMasterAndTempMaterialIds(materialMasterAndTempMaterialIdsResponse.data)
        }
    }

    const handleUploadFile = (e) => {
        const reader = new FileReader()
        if(e.target.files[0]) {
            reader.readAsArrayBuffer(e.target.files[0])
            reader.onload = (e) => {
                const data = e.target.result
    
                const workbook = read(data)
                const worksheet = workbook.Sheets[workbook.SheetNames[0]]
                const productsParsedData = utils.sheet_to_json(worksheet)

                newUploadFileValidation(productsParsedData)

                if (fileInputRef.current) {
                    fileInputRef.current.value = null;
                }
            }
        }
        reader.onabort = () => console.log('file reading was aborted');
		reader.onerror = () => console.log('file reading has failed');
	    
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    }

    const rcDataTypes = [
        {columnName: "SRNO", keyName: 'srNo', dataType: 'Integer', required: true, nullValidations: ["ALL"] },
        {columnName: "RATE CONTRACT ID", keyName: 'buyerRateContractId', dataType: 'Integer', required: false, nullValidations: []},
        {columnName: "STATUS", keyName: "status", dataType: 'String', required: true, nullValidations: ["ALL"]},
        {columnName: "BRANCH NAME", keyName: 'branchName', dataType: 'String', required: true, nullValidations: ["ALL"]},
        {columnName: "COMPANY ERP CODE", keyName: 'companyERPCode',dataType: 'String', required: false, nullValidations: ["ERPCODE MANDATORY"], maxLength: 255},
        {columnName: "MATERIAL ID", keyName: 'materialId', dataType: 'Integer', required: false, nullValidations: [] },
        {columnName: "PRODUCT NAME", keyName: 'companyProdName', dataType: 'String', required: true, nullValidations: ["ALL"], maxLength: 255, minLength: 3},
        {columnName: "PRODUCT SPECIFICATIONS",keyName: 'companyProdSpec', dataType: 'String', required: true, nullValidations: ["ALL"], maxLength: 1000, minLength: 3},
        {columnName: "CATEGORY", keyName: 'companyERPCategory', dataType: 'String', required: true, nullValidations: ["ALL"], maxLength: 255},
        {columnName: "SUB CATEGORY", keyName: 'companyERPSubCategory', dataType: 'String', nullValidations: [], maxLength: 255},
        {columnName: "UOM", keyName: 'companyERPUOM', dataType: 'String', required: true, nullValidations: ["ALL"], maxLength: 255},
        {columnName: "HSN", keyName: 'companyHSNOverride', dataType: 'Integer', required: false, nullValidations: ["ARIBA", "MEPLATO", "CONSUMER"]},
        {columnName: "GST(%)", keyName: 'companyGSTOverride', dataType: 'GSTRate', required: false, nullValidations: ["ARIBA", "MEPLATO", "CONSUMER"]},
        {columnName: "UNSPSC", keyName: 'UNSPSC', dataType: 'String', required: true, nullValidations: ["MEPLATO"], maxLength: 255},
        {columnName: "LIST PRICE", keyName: 'listPrice', dataType: 'Real', required: true, nullValidations: []},
        {columnName: "UNIT PRICE", keyName: 'unitPrice', dataType: 'Real', required: true, nullValidations: ["ALL"]},
        {columnName: "LEADTIME (In days)", keyName: 'leadTime', dataType: 'Integer', required: true, nullValidations: ["ALL"]},
        {columnName: "VALIDITY PERIOD", keyName: 'validityPeriod', dataType: 'Date', required: true, nullValidations: []},
        {columnName: "VAT Code", keyName: 'VATCode', dataType: 'String', required: true, nullValidations: ["MEPLATO"], maxLength: 12},
        {columnName: "QTY MULTIPLE", keyName: 'companyQtyMultiplier', dataType: 'Real', required: true, nullValidations: []},
        {columnName: "MIN ORDER QTY", keyName: 'minOrderQty', dataType: 'Real', required: true, nullValidations: []},
        {columnName: "MAKE", keyName: 'make', dataType: 'String', required: true, nullValidations: [], maxLength: 100},
        {columnName: "PART NO", keyName: 'partNo', dataType: 'String', required: true, nullValidations: [], maxLength: 100},
        {columnName: "IMAGE URL", keyName: 'imageURL', dataType: 'String', required: true, nullValidations: []},
        {columnName: "REMARKS", keyName: 'remarks', dataType: 'String', required: true, nullValidations: [], maxLength: 150},
        {columnName: "MONTHLY QTY", keyName: 'monthlyQty', dataType: 'Real', nullValidations: []},
        {columnName: "MONTHLY VALUE", keyName: 'monthlyValue', dataType: 'Real', nullValidations: []}
    ]

    const checkDataType = (value, type) => {
        if (type === "Integer"){
            let obj = {
                isValid: !_.isNaN(value),
                value: parseInt(value)
            }
            return obj
        }else if (type === "Real"){
            let obj = {
                isValid: !_.isNaN(value),
                value: parseFloat(value)
            }
            return obj
        }else if (type === "String"){
            let obj = {
                isValid: _.isString(value.toString()),
                value: value.toString().trim()
            }
            return obj
        }else if (type === "Date"){
            if (_.isInteger(value)){
                value = excelSerialToJSDate(value)
            }
            let obj = {
                isValid: moment(value, "YYYY-MM-DD", true).isValid(),
                value: value
            }
            return obj
        }else if (type === "GSTRate"){
            let obj = {
                isValid: !_.isNaN(value) && !(parseFloat(value) > 0 && parseFloat(value) < 1),
                value: parseFloat(value)
            }
            return obj
        }
    }

    const newUploadFileValidation = async (uploadSheetData) => {
        let updatedRateContractsData = []
        let errorMsgsArr = []
        let confirmMessageArr = []

        let companyERPCodeMapsWithERPCode = companyERPCodeMapData.filter(eachERPCodeMap => eachERPCodeMap.companyERPCode)
        let companyERPCodeMapsWithoutERPCode = companyERPCodeMapData.filter(eachERPCodeMap => !eachERPCodeMap.companyERPCode)

        for (let j = 0; j < uploadSheetData.length; j++) {
            const rateContractProduct = uploadSheetData[j]

            const isProductInactive = rateContractProduct["STATUS"] === "INACTIVE"
            
            let newRateContractProduct = {
                companyId: id,
                statusId: 1,
                userId: userId,
                meplatoCatalogId: null   
            }

            if (companyDetails.thirdPartyIntegrations?.meplatoCatalogId) {
                newRateContractProduct.meplatoCatalogId = companyDetails.thirdPartyIntegrations.meplatoCatalogId
            }

            let relatedERPCodeMapData = null
            let relatedBuyerRateContract = null
            let relatedMaterialIdData = null
            let isERPCodeExists = false
            let isHSNEntryAllowed = pmCompanyConfig.HSNEntryAllowed
           
            if (!isHSNEntryAllowed){
                newRateContractProduct["HSN"] = pmCompanyConfig.defaultHSNCode
                rateContractProduct["HSN"] = pmCompanyConfig.defaultHSNCode

                newRateContractProduct["GST(%)"] = pmCompanyConfig.defaultGSTRate
                rateContractProduct["GST(%)"] = pmCompanyConfig.defaultGSTRate
            }
            
            rcDataTypes.map(eachDataType => {
                let relatedRateContractValue = rateContractProduct[eachDataType.columnName]

                let meplatoCondition = eachDataType.nullValidations.includes("MEPLATO") && newRateContractProduct.meplatoCatalogId
                let aribaCondition = eachDataType.nullValidations.includes("ARIBA") && companyDetails.tags?.isAribaIntegrationEnabled
                let consumerOrderCondition = eachDataType.nullValidations.includes("CONSUMER") && companyDetails.tags?.canDoConsumerRequest
                let companyERPCodeMandatoryCondition = eachDataType.nullValidations.includes("ERPCODE MANDATORY") && companyDetails.tags?.isERPCodeMandatory
                let HSNCodeMandaoryCondtion = isHSNEntryAllowed && (meplatoCondition || aribaCondition || consumerOrderCondition)

                if (!relatedRateContractValue && (eachDataType.columnName !== "GST(%)" && relatedRateContractValue !== 0)){
                    if (eachDataType.nullValidations.length){
                        if (eachDataType.nullValidations.includes("ALL") || (HSNCodeMandaoryCondtion || companyERPCodeMandatoryCondition)){
                            errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], type: 'Missing', severity: 'error', detail: `value missing`})
                        }
                    }
                }
                else if (relatedRateContractValue || (eachDataType.columnName === "GST(%)" && relatedRateContractValue === 0)){
                    let { isValid, value } = checkDataType(relatedRateContractValue, eachDataType.dataType)
                    if (isValid){
                        if (!eachDataType.maxLength || (eachDataType.maxLength && value.length <= eachDataType.maxLength) && (!eachDataType.minLength || (eachDataType.minLength && value.length >= eachDataType.minLength))){
                            if (eachDataType.columnName === "RATE CONTRACT ID"){
                                relatedBuyerRateContract = allBuyerRateContracts.find(eachBuyerRateContract => eachBuyerRateContract.buyerRateContractId === rateContractProduct[eachDataType.columnName])
                                if(!relatedBuyerRateContract){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], type: 'Invalid', severity: 'error', value: value, detail: `Provided Rate Contract Id is not present in this buyer company`})
                                }
                            }

                            if (eachDataType.columnName === 'MATERIAL ID') {
                                relatedMaterialIdData = materialMasterAndTempMaterialIds.find(materialItem => materialItem.materialId == rateContractProduct[eachDataType.columnName])
                                if(!relatedMaterialIdData){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], type: 'Invalid', severity: 'error', value: value, detail: `Provided Material is not present in Material Master`})
                                }
                            }

                            if (eachDataType.columnName === 'BRANCH NAME'){
                                if(rateContractProduct[eachDataType.columnName].toLowerCase() === "all") {
                                    newRateContractProduct.branchId = 0
                                } else {
                                    const relatedCompanyBranch = companyBranches.find(branch => branch.branchName.toLowerCase() === rateContractProduct["BRANCH NAME"].toLowerCase())
                                    if(!relatedCompanyBranch){
                                        errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], type: 'Invalid',severity: 'error', value: value, detail: `Provided Branch Name ${value} is not valid`})
                                    }else{
                                        newRateContractProduct.branchId = relatedCompanyBranch.branchId
                                    }
                                }
                            }

                            if (eachDataType.columnName === "HSN"){
                                let relatedHSNCodes = HSNMasterData.find(eachHSN => eachHSN.HSNCode === value)
                                if (!relatedHSNCodes){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided ${eachDataType.columnName} ${value} is Invalid.`})
                                } else if(rateContractProduct["GST(%)"]){
                                    let relatedGSTRate = companyGSTRateData.find(eachGSTRate => eachGSTRate.GSTRate == rateContractProduct["GST(%)"])
                                    if(!relatedGSTRate){
                                        errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided HSN ${value} AND GST are not matched.`})
                                    }
                                }
                            }

                            if (eachDataType.columnName === "GST(%)"){
                                let relatedGSTRate = companyGSTRateData.find(eachGSTRate => eachGSTRate.GSTRate === value)
                                if(!relatedGSTRate){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided GST ${value}% is Invalid.`})
                                }
                            }

                            if (eachDataType.columnName === 'STATUS'){
                                if (!['ACTIVE', 'INACTIVE'].includes(rateContractProduct[eachDataType.columnName])){
                                    errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided ${eachDataType.columnName} "${value}" is Invalid, it should be either ACTIVE or INACTIVE.`})
                                }
                            }

                            if (eachDataType.columnName === 'MONTHLY VALUE') {
                                const monthlyQty = rateContractProduct['MONTHLY QTY']
                                const unitPrice = rateContractProduct['UNIT PRICE']
                                const monthlyValue = relatedRateContractValue
                            
                                const isMonthlyQtyEntered = monthlyQty !== null && monthlyQty !== ''
                                const isMonthlyValueEntered = monthlyValue !== null && monthlyValue !== ''
                                
                                if (isMonthlyQtyEntered && isMonthlyValueEntered) {
                                    const calculatedMonthlyValue = parseInt(monthlyQty) * parseInt(unitPrice)
                                    const actualMonthlyValue = parseInt(monthlyValue)

                                    if (Math.abs(calculatedMonthlyValue - actualMonthlyValue) > actualMonthlyValue * 0.02) {
                                        errorMsgsArr.push({
                                            field: eachDataType.columnName,
                                            srNo: rateContractProduct["SRNO"],
                                            severity: 'error',
                                            type: 'mismatched',
                                            value,
                                            detail: `The product of Unit Price and Monthly Quantity should approximately match the entered Monthly Value. A deviation of up to 2% is allowed, but a larger discrepancy was detected (Expected: ${calculatedMonthlyValue}, Entered: ${actualMonthlyValue}). Please review the values.`
                                        })
                                    }
                                }
                            }

                            newRateContractProduct[eachDataType.keyName] = value
                            newRateContractProduct[eachDataType.columnName] = value
                        }else{
                            if (eachDataType.maxLength && value.length > eachDataType.maxLength) {
                                errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Exceeded Length', value: value, detail: `Provided ${eachDataType.columnName} ${value} is not acceptable as it exceeded the length(${eachDataType.maxLength}).`})
                            } else if (eachDataType.minLength && value.length < eachDataType.minLength) {
                                errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Below Minimum Length', value: value, detail: `Provided ${eachDataType.columnName} ${value} is not acceptable as it is below the minimum length(${eachDataType.minLength}).`})
                            }
                        }
                    }else{
                        errorMsgsArr.push({field: eachDataType.columnName, srNo: rateContractProduct["SRNO"], severity: 'error', type: 'Invalid', value: value, detail: `Provided ${eachDataType.columnName} ${value} is invalid.`})
                    }
                }
            })

            if (newRateContractProduct.companyERPCode) {
                relatedERPCodeMapData = companyERPCodeMapsWithERPCode.filter(eachERPCodeMap => eachERPCodeMap.companyERPCode.toLowerCase() === newRateContractProduct.companyERPCode.toString().toLowerCase())
                if (relatedERPCodeMapData.length){
                    isERPCodeExists = true
                }
            } else {
                relatedERPCodeMapData = companyERPCodeMapsWithoutERPCode.filter(eachERPCodeMap => {
                    if(eachERPCodeMap.companyProdName?.toLowerCase() === newRateContractProduct.companyProdName?.toLowerCase() && eachERPCodeMap.companyProdSpec?.toLowerCase() === newRateContractProduct.companyProdSpec?.toLowerCase() && eachERPCodeMap.companyERPUOM?.toLowerCase() === newRateContractProduct.companyERPUOM?.toLowerCase() && eachERPCodeMap.statusId === 1){
                        return true
                    }
                    return false
                })
            }

            if(!newRateContractProduct.validityPeriod || !moment(newRateContractProduct.validityPeriod, "YYYY-MM-DD", true).isValid()) {
                const oneYearFromNow = new Date()
                oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)
                newRateContractProduct.validityPeriod = oneYearFromNow
            }else{
                const oneYearFromNow = new Date()
                oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1)

                let sheetValidityDate = moment(newRateContractProduct.validityPeriod).toDate()

                if (sheetValidityDate.getTime() > oneYearFromNow.getTime()) {
                    newRateContractProduct.validityPeriod = oneYearFromNow
                } else {
                    newRateContractProduct.validityPeriod = sheetValidityDate
                }

                if(sheetValidityDate.getTime() < moment().toDate().getTime()){
                    newRateContractProduct.validityPeriod = oneYearFromNow
                }
            }

            if (newRateContractProduct.make) {
                let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandName.toLowerCase() === newRateContractProduct.make.toLowerCase())
                if (relatedMaterialBrand) {
                    newRateContractProduct.brandId = relatedMaterialBrand.brandId
                }
            }

            let confirmMessage = ""
            if(isProductInactive){
                confirmMessage = `Item will be deleted`
            } else if ((relatedERPCodeMapData && relatedERPCodeMapData.length > 0) && (relatedMaterialIdData === null)) {
                confirmMessage = `ERPCode already exist with ${relatedERPCodeMapData.length} product - these will be updated.\nMaterialId doesn't exists. It will create new temp id.`
            } else if (relatedERPCodeMapData && relatedERPCodeMapData.length > 0) {
                if (isERPCodeExists){
                    confirmMessage = `ERPCode already exist with ${relatedERPCodeMapData.length} product - these will be updated.`
                }else {
                    confirmMessage = `Given product details already exists with ${relatedERPCodeMapData.length} product - these will be updated.`
                }
            } else if (relatedMaterialIdData === null) {
                confirmMessage = `MaterialId doesn't exists. It will create new temp id`
            }

            if(confirmMessage){
                confirmMessageArr.push({
                    srNo: rateContractProduct["SRNO"],
                    message: confirmMessage
                })
            }

            updatedRateContractsData.push(newRateContractProduct)
        }
        
        updatedRateContractsData = updatedRateContractsData.map(eachBuyerRateContract => ({...eachBuyerRateContract, materialIdString: eachBuyerRateContract.materialId?.toString()}))

        let rateContractsWithERPCodeAndMaterialIds = updatedRateContractsData.filter(eachBuyerRateContract => eachBuyerRateContract.status === "ACTIVE" && (eachBuyerRateContract.companyERPCode || eachBuyerRateContract.materialIdString))
        let rateContractsWithoutERPCodeAndMaterialIds = updatedRateContractsData.filter(eachBuyerRateContract => eachBuyerRateContract.status === "ACTIVE" && (!eachBuyerRateContract.companyERPCode && !eachBuyerRateContract.materialIdString))
        
        let duplicateRateContractsWithERPCodeAndMaterialIds = getDuplicatesInArray(rateContractsWithERPCodeAndMaterialIds, ["companyERPCode", "materialIdString", "branchName"])
        let duplicateRateContractsWithoutERPCodeAndMaterialIds = getDuplicatesInArray(rateContractsWithoutERPCodeAndMaterialIds, ["companyProdName", "companyProdSpec", "companyERPUOM"])
        
        let duplicateRateContracts = [...duplicateRateContractsWithERPCodeAndMaterialIds, ...duplicateRateContractsWithoutERPCodeAndMaterialIds]
        if (duplicateRateContracts.length){
            duplicateRateContracts.map(eachDuplicateRateContract => {
                errorMsgsArr.push({field: 'Rate Contract', type: 'Duplicate', severity: 'error', srNo: eachDuplicateRateContract.srNo, detail: 'Given Rate contracts have some duplicates. Each rate contract must be unique.'})
            })
        }

        setValidRateContractProducts(updatedRateContractsData)
        if (errorMsgsArr.length){
            setErrorMessagesData(errorMsgsArr)
            setVisibleErrorMessageModal(true)
            return 
        }

        if(confirmMessageArr.length > 0){
            setVisibleUploadFileConfirmModal(true)
            setConfirmMessageList(confirmMessageArr)
        }else{
            handleConfirmUploadFileSubmit(updatedRateContractsData)
        }
    }

    const pollUploadStatus = async (companyId) => {
        try {
            const response = await getRateContractUploadStatus(companyId)
            setUploadStatus(response.data.lastRCUploadStatus)

            if (response.data.lastRCUploadStatus === 'PROCESSING') {
                setIsPolling(true)
                setTimeout(() => pollUploadStatus(companyId), 5000)
            } else if (response.data.lastRCUploadStatus === 'COMPLETED') {
                setIsPolling(false)
                getBuyerRateContractsData()
                dispatch(raiseToast({ severity: 'success', detail: `Rate contract upload completed successfully. ${response.data.lastRCUploadCount} items processed.`, life: 5000 }))
            } else if (response.data.lastRCUploadStatus === 'FAILED') {
                setIsPolling(false)
                dispatch(raiseToast({ severity: 'error', detail: `Upload failed: ${response.data.lastRCUploadError || 'Unknown error'}`, life: 5000 }))
            }
        } catch (error) {
            console.error('Error polling upload status:', error)
            setIsPolling(false)
            dispatch(raiseToast({ severity: 'error', detail: 'Error checking upload status', life: 3000 }))
        }
    }

    const handleConfirmUploadFileSubmit = async(validRateContractProducts, updateOnlyPrice) => {
        if (window.confirm("Are you sure you want to continue...?")) {
            setIsLoaderVisible(true)
            try {
                let response
                if(updateOnlyPrice){
                    response = await updateBulkRateContractPriceUploadSheet(validRateContractProducts)
                } else {
                    response = await insertBulkRateContractUploadSheet(validRateContractProducts)
                }

                if(response.failure){
                    if (response.data.error === 'UPLOAD_IN_PROGRESS') {
                        dispatch(raiseToast({ severity: 'error', detail: 'Another rate contract upload is in progress. Please wait for it to complete.', life: 3000 }))
                    } else {
                        dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
                    }
                } else {
                    dispatch(raiseToast({ severity: 'info', detail: 'Rate contract upload started. You will be notified when it completes.', life: 5000 }))
                    setVisibleUploadFileConfirmModal(false)
                    
                    // Start polling for status
                    setIsPolling(true)
                    pollUploadStatus(id)
                }
            } catch (error) {
                dispatch(raiseToast({ severity: 'error', detail: error.message || 'An error occurred while uploading rate contracts', life: 3000 }))
            } finally {
                setIsLoaderVisible(false)
            }
        } else {
            uploadMenu.current.value = '';
        }
    }

    const confirmMessageForUploadFile = () => {
        const confirmMessageColumns = [
            {
                header: 'Sr No',
                field: 'srNo',
            },
            {
                header: 'Confirm Message',
                field: 'message',
            },
        ]
        
        return (
            <Dialog header="Confirm message" visible={visibleUploadFileConfirmModal} style={{ width: '60vw', minHeight: "35%" }} onHide={() => setVisibleUploadFileConfirmModal(false)}>
                <div className="">
                    <Table
                        tableColumns={confirmMessageColumns}
                        data={confirmMessageList}
                        scrollable={"true"}
                    />
                    <div className='mt-3 flex justify-content-end'>
                        <Button label={"Confirm"} onClick={() => handleConfirmUploadFileSubmit(validRateContractProducts)} /> 
                        <Button label={"Update Only Price"} onClick={() => handleConfirmUploadFileSubmit(validRateContractProducts, true)} />
                    </div>
                </div>
            </Dialog>
        )
    }

    const getExistingRateContractDataByValues = async (data) => {
        const existingRateContractDataResponse = await getBuyerRateContractByValues(data)
        console.log("existingRateContractData - response", existingRateContractDataResponse)
        if(existingRateContractDataResponse.failure){
            dispatch(raiseToast({ severity: 'error', detail: existingRateContractDataResponse.data.error, life: 3000 }))
        }else{
            setExistingRateContractObj(existingRateContractDataResponse.data)
            if(existingRateContractDataResponse.data){
                rateContractObj.buyerRateContractId = existingRateContractDataResponse.data.buyerRateContractId
                rateContractObj.unitPrice = existingRateContractDataResponse.data.unitPrice
                rateContractObj.leadTime = existingRateContractDataResponse.data.leadTime
                rateContractObj.validityPeriod = existingRateContractDataResponse.data.validityPeriod
                rateContractObj.statusId = existingRateContractDataResponse.data.statusId
            }else{
                rateContractObj.buyerRateContractId = ''
                rateContractObj.unitPrice = ''
                rateContractObj.leadTime = ''
                rateContractObj.validityPeriod = ''
            }
            setRateContractObj({...rateContractObj})
        }
    }

    const addNewBuyerRateContractData = async(data) => {
        data.userId = userId
        data.companyId = id
        data.meplatoCatalogId = "62B923A70B" //null

        if(companyDetails?.thirdPartyIntegrations?.meplatoCatalogId){
            data.meplatoCatalogId = companyDetails?.thirdPartyIntegrations?.meplatoCatalogId
        }

        let companyERPCodeExistsData = companyERPCodeMapData.filter(eachERPCodeMap => eachERPCodeMap.companyERPCode)
        let companyERPCodeNotExistsData = companyERPCodeMapData.filter(eachERPCodeMap => !eachERPCodeMap.companyERPCode)
        
        let relatedERPCodeMapData = null
        if(data.companyERPCode){
            relatedERPCodeMapData = companyERPCodeExistsData.filter(eachERPCodeMap => eachERPCodeMap.companyERPCode?.toLowerCase() === data.companyERPCode.toLowerCase() && eachERPCodeMap.statusId === 1)
        }else{
            relatedERPCodeMapData = companyERPCodeNotExistsData.filter(eachERPCodeMap => {
                if(eachERPCodeMap?.companyProdName?.toLowerCase() === data?.companyProdName?.toLowerCase() && eachERPCodeMap.statusId === 1){
                    return true
                }
                return false
            })
        }

        let relatedMaterialIdData = null
        if(data.materialId){
            relatedMaterialIdData = materialMasterAndTempMaterialIds.find(materialItem => materialItem.materialId === parseInt(data.materialId))
            if(!relatedMaterialIdData){
                return dispatch(raiseToast({ severity: 'warn', detail: `MaterialId ${data.materialId} doesn't exists. Please enter correct material id`, life: 3000 }))
            }
        }

        const monthlyValueValidation = validateMonthlyValue(data.monthlyQty, data.unitPrice, data.monthlyValue)
        if (!monthlyValueValidation.isValid) {
            return dispatch(raiseToast({
                severity: 'error',
                detail: `The product of Unit Price and Monthly Quantity should approximately match the entered Monthly Value. A deviation of up to 2% is allowed, but a larger discrepancy was detected (Expected: ${monthlyValueValidation.expected}, Entered: ${monthlyValueValidation.actual}). Please review the values.`
            }))
        }

        let confirmMessage = "Do you want to add buyer rate contract..?"
        if ((relatedERPCodeMapData && relatedERPCodeMapData.length > 0) && (relatedMaterialIdData === null)) {
            confirmMessage = `ERPCode already exist with ${relatedERPCodeMapData.length} product - these will be updated.\nMaterialId doesn't exists. It will create new temp id.\nAre you sure you want to continue?`
        }
        else if (relatedERPCodeMapData && relatedERPCodeMapData.length > 0) {
            confirmMessage = `ERPCode already exist with ${relatedERPCodeMapData.length} product - these will be updated.\nAre you sure you want to continue?`
        }
        else if (relatedMaterialIdData === null) {
            confirmMessage = `MaterialId doesn't exists. It will create new temp id.\nAre you sure you want to continue?`
        }

        if(data.make){
            let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandName.toLowerCase() === data.make.toLowerCase())
            if(relatedMaterialBrand){
                data.brandId = relatedMaterialBrand.brandId
            }
        }

        if (window.confirm(confirmMessage)) {
            setIsLoaderVisible(true)
            const insertBuyerRateContractResponse = await insertBuyerRateContract(data)
            console.log("insertBuyerRateContract - response", insertBuyerRateContractResponse)

            if(insertBuyerRateContractResponse.failure){
                dispatch(raiseToast({ severity: 'error', detail: insertBuyerRateContractResponse.data.error, life: 3000 }))
            }else{
                dispatch(updateBuyerRateContractData([{...insertBuyerRateContractResponse.data}, ...buyerRateContractData, ]))
                setRateContractObj({...initialBuyerRateContractDetails})
                setVisibleAddRateContractProduct(false)
                dispatch(raiseToast({ severity: 'success', detail: "Added rate contract product successfully", life: 3000 }))
            }

            setIsLoaderVisible(false)
        }
    }

    const updateBuyerRCData = async(data) => {
        data.updatedBy = userId
        let companyERPCodeExistsData = companyERPCodeMapData.filter(eachERPCodeMap => eachERPCodeMap.companyERPCode)
        let companyERPCodeNotExistsData = companyERPCodeMapData.filter(eachERPCodeMap => !eachERPCodeMap.companyERPCode)
        
        let relatedERPCodeMapData = null
        if(data.companyERPCode){
            relatedERPCodeMapData = companyERPCodeExistsData.filter(eachERPCodeMap => eachERPCodeMap.companyERPCode?.toLowerCase() === data.companyERPCode?.toLowerCase())
        }else{
            relatedERPCodeMapData = companyERPCodeNotExistsData.filter(eachERPCodeMap => {
                if(eachERPCodeMap.companyProdName?.toLowerCase() === data.companyProdName?.toLowerCase()){
                    return true
                }
                return false
            })
        }

        if(data.unitPrice !== previousUnitPrice){
            data.isUnitPriceChanged = true
        }

        if(data.make){
            let relatedMaterialBrand = materialBrands.find(eachBrand => eachBrand.brandName.toLowerCase() === data.make.toLowerCase())
            if(relatedMaterialBrand){
                data.brandId = relatedMaterialBrand.brandId
            }
        }

        const monthlyValueValidation = validateMonthlyValue(data.monthlyQty, data.unitPrice, data.monthlyValue)
        if (!monthlyValueValidation.isValid) {
            return dispatch(raiseToast({
                severity: 'error',
                detail: `The product of Unit Price and Monthly Quantity should approximately match the entered Monthly Value. A deviation of up to 2% is allowed, but a larger discrepancy was detected (Expected: ${monthlyValueValidation.expected}, Entered: ${monthlyValueValidation.actual}). Please review the values.`
            }))
        }

        let confirmMessage = "Do you want to update buyer rate contract..?"
        if(relatedERPCodeMapData && relatedERPCodeMapData.length > 0){
            confirmMessage = `ERPCode already exist with ${relatedERPCodeMapData.length} product - these will be updated.\nAre you sure you want to continue?`
        }
        
        if (window.confirm(confirmMessage)) {
            setIsLoaderVisible(true)
            const updateBuyerRateContractDataResponse = await updateBuyerRateContract(data.buyerRateContractId , data)
            
            if(updateBuyerRateContractDataResponse.failure){
                dispatch(raiseToast({ severity: 'error', detail: updateBuyerRateContractDataResponse.data.error, life: 3000 }))
            }else{

                const updatedBuyerRateContract = buyerRateContractData.map((eachRateContract) => {
                    if(eachRateContract.buyerRateContractId === data.buyerRateContractId){
                        return {
                            ...updateBuyerRateContractDataResponse.data
                        }
                    }else{
                        return {...eachRateContract}
                    }
                })

                dispatch(updateBuyerRateContractData(updatedBuyerRateContract))
                setVisibleEditRateContractProduct(false)
                dispatch(raiseToast({ severity: 'success', detail: "Updated rate contract product successfully", life: 3000 }))
            }

            setIsLoaderVisible(false)
        }
    }

    const deleteBuyerRateContract = async (buyerRateContractId) => {
        if (window.confirm("To add this ERP-Code/ MaterialId again in rate contract within 48 hours, approval will be required. Are you sure you want to continue?")) {
            setIsLoaderVisible(true)

            let deleteBuyerRateContractResponse = await deleteBuyerRateContractById(buyerRateContractId)
            console.log("deleteBuyerRateContract - response", deleteBuyerRateContractResponse)

            if(deleteBuyerRateContractResponse.failure){
                dispatch(raiseToast({ severity: 'error', detail: deleteBuyerRateContractResponse.data.error, life: 3000 }))
            }else{
                const relatedBuyerRateContractData = buyerRateContractData.filter(eachRateContract => eachRateContract.buyerRateContractId !== buyerRateContractId)
                dispatch(updateBuyerRateContractData([...relatedBuyerRateContractData]))
                setVisibleEditRateContractProduct(false)
                dispatch(raiseToast({ severity: 'success', detail: "Rate contract product deleted successfully", life: 3000 }))
            }

            setIsLoaderVisible(false)
        }
    }

    const onClickEditRateContract = (row) => {
        setInitialRateContractObj(row)
        let rateContractProduct = {
            ...row,
            ...row.companyERPCodeMap,
        }
        
        if(row.branchId === 0){
            rateContractProduct.branchId = {branchName:"ALL", branchId:0}
        }else{
            if(row.companyBranches && row.companyBranches.length > 0){
                rateContractProduct.branchId = row.companyBranches[0]
            }
        }
        
        setEditRateContractObj(rateContractProduct)
        setPreviousUnitPrice(rateContractProduct.unitPrice)
        setVisibleEditRateContractProduct(true)
    }

    const actionMenuItems = [
        {
            label: 'Add Product',
            icon: '',
            command: () => {
                setVisibleAddRateContractProduct(true)
            },
            permissions: [30],
            disabled: companyDetails?.statusId === 2,
            tooltip: companyDetails?.statusId === 2 && "Company is inactive, can't add rate contract",
        }
    ]

    const handleOnClickFilter = () => {
        setIsFilterShown(current => !current)
    }

    const handleCloseAddRateContractProductModal = () => {
        setRateContractObj({...initialBuyerRateContractDetails})
        setVisibleAddRateContractProduct(false)
    }

    const actionButtons = [
        {
            label: "Action",
            command: (event) => actionMenu.current?.toggle(event),
        },
        {
            icon: "pi pi-filter",
            label: "Filter",
            command: () => handleOnClickFilter(),
            // className: isSearchActive ? "active-group-button" : ""
        },
    ]

    let uploadRCDisabledTooltipTxt = ""
    if (companyDetails?.statusId === 2){
        uploadRCDisabledTooltipTxt = "Upload rate contract sheet is disabled because the company is inactive."
    }
    
    return (
        <div className="container relative">
            <div className="company-step-header" style={{ top: 50 }}>
                <Steps model={items} activeIndex={4} readOnly={false} />
            </div>
            <Toast ref={toast} />
            <div className="p-card" style={{ borderTopLeftRadius: "0px", borderTopRightRadius: "0px"}}>
                <div className="flex flex-column md:flex-row md:justify-content-between mt-1 mb-2">
                    <div className="">
                        <h4 className="mb-2 md:m-0">{companyDetails?.companyName} - Rate Contract</h4>
                    </div>
                    <div className="flex gap-2 justify-content-end">
                        <Menu model={actionMenuItems} popup menuRef={actionMenu} />
                        <ButtonGroup buttons={actionButtons} />
                        <div className="ml-1">
                            <Menu id='upload-menu' model={uploadOptions} popup menuRef={uploadMenu} />
                            <Button icon="pi pi-upload" className="h-2rem w-2rem p-2" aria-controls="upload-menu" onClick={(event) => uploadMenu.current.toggle(event)} disabled= {companyDetails?.statusId === 2} tooltip={uploadRCDisabledTooltipTxt} tooltipOptions={{position: "top", showOnDisabled: true}} />  
                            <input type="file" accept=".xlsx, .xls" className='hidden' id='upload-xl-form' onChange={handleUploadFile} ref={fileInputRef} />
                        </div>
                    </div>
                </div>
                <div className='flex flex-row'>
                    <div className="" style={{ order: "1", width: isFilterShown && !isMobileDevice? "82%" : "100%", maxHeight: "'calc(100%-100px)'"}}>
                        <div className='p-card mb-0' >
                            <div className="flex-grow-1" >
                                <BuyerRateContractTable
                                    onClickEditRateContract={onClickEditRateContract}
                                    deleteBuyerRateContract={deleteBuyerRateContract}
                                />
                            </div>
                        </div>
                    </div>

                    {
                        isFilterShown && !isMobileDevice &&
                        <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end">
                            <Search
                                searchInputs={searchInputs}
                                setSearchInputs={setSearchInputs}
                                companyId={id}
                                companyBranches={companyBranches}
                                statusList={statusList}
                                rcDataTypes={rcDataTypes}
                                pmCompanyConfig={pmCompanyConfig}
                            />
                        </div>
                    }

                {
                    isFilterShown && isMobileDevice && 
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px" }} className="justify-content-end ">
                        <Sidebar position='right' visible={isFilterShown} onHide={() => setIsFilterShown(false)}>
                            <Search
                                searchInputs={searchInputs}
                                setSearchInputs={setSearchInputs}
                                companyId={id}
                                companyBranches={companyBranches}
                                statusList={statusList}
                                rcDataTypes={rcDataTypes}
                                pmCompanyConfig={pmCompanyConfig}
                            />
                        </Sidebar>
                    </div>
                }
                </div>
                {
                    visibleAddRateContractProduct ? 
                        <Dialog  header="Product details" visible={visibleAddRateContractProduct} style={{ width: '65vw', minHeight: "35%" }} onHide={() => handleCloseAddRateContractProductModal()}>
                            <AddRateContractProduct
                                companyId={id}
                                companyBranches={companyBranches}
                                companyERPCodeMapData={companyERPCodeMapData}
                                rateContractObj={rateContractObj}
                                setRateContractObj={setRateContractObj}
                                existingRateContractObj={existingRateContractObj}
                                getExistingRateContractDataByValues={getExistingRateContractDataByValues}
                                addNewBuyerRateContractData={addNewBuyerRateContractData}
                                maxValidityPeriod={maxValidityPeriod}
                                HSNMasterData={HSNMasterData}
                                uomsData={uomsData}
                                companyGSTRateData={companyGSTRateData}
                                companyDetails = {companyDetails}
                            />
                        </Dialog>
                        :
                        ""
                }
                {
                    visibleEditRateContractProduct ? 
                        <Dialog  header="Product details" visible={visibleEditRateContractProduct} style={{ width: '65vw', minHeight: "35%" }} onHide={() => setVisibleEditRateContractProduct(false)}>
                            <EditRateContractProduct
                                companyId={id}
                                companyDetails={companyDetails}
                                companyBranches={companyBranches}
                                companyERPCodeMapData={companyERPCodeMapData}
                                editRateContractObj={editRateContractObj}
                                setEditRateContractObj={setEditRateContractObj}
                                existingRateContractObj={existingRateContractObj}
                                getExistingRateContractDataByValues={getExistingRateContractDataByValues}
                                updateBuyerRCData={updateBuyerRCData}
                                deleteBuyerRateContract={deleteBuyerRateContract}
                                HSNMasterData={HSNMasterData}
                                uomsData={uomsData}
                                companyGSTRateData={companyGSTRateData}
                                initialRateContractObj={initialRateContractObj}
                            />
                        </Dialog>
                        :
                        ""
                }
                {
                    visibleUploadFileConfirmModal && confirmMessageForUploadFile(validRateContractProducts)
                }
            </div>
            <ErrorMsgsModal 
                errorMessagesData={errorMessagesData} 
                visibleErrorMessageModal={visibleErrorMessageModal} 
                setVisibleErrorMessageModal={setVisibleErrorMessageModal} 
                rateContractProducts={validRateContractProducts}
                handleConfirmUploadFileSubmit={handleConfirmUploadFileSubmit}
            />
            <Loading visible={isLoaderVisible} />
        </div>
    )
}

export default BuyerRateContract ;